module.exports = __webpack_public_path__ + "static/img/activity_sdy_05-2.67f2cac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_05-2.jpg
// module id = quIZ
// module chunks = 0